import { Etiqueta } from "@shared/models";
import { FuncionalidadPersonalizacion } from "@shared/models/funcionalidadPersonalizacion";
import { EtiquetaViewModel } from "./etiqueta-view-model";

export abstract class BaseEtiqueta {
    abstract etiqueta: EtiquetaViewModel;
    abstract obtenerFuncionalidadPersonalizacion(): FuncionalidadPersonalizacion;
}
